
import { useState } from 'react';
import { sendOTP } from '../api';
import FormikComponent from '../../component/formikComponent';
import OtpPopup from './otpPopup';
import { FullPageLoader } from '../../component/helper';


const ReConfirm = ({ setReConfirm, values, data }) => {
    const labelMap = {
        promo_sms: "SMS",
        promo_whatsapp: "WhatsApp",
        promo_email: "Email",
        promo_phone: "Phone"
    };
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const saveUserSetting = async () => {
        setLoading(true);

        let otpData = {
            mobile: data?.phone,
            company_key: data?.c_key,
            type: 'otp-communication-preferences'
        }
        const response = await sendOTP(otpData);
        if (Number(response.code) === 1) {
            // OTP sent successfully, show OTP input
            setShow(true);
        } else {
            // Handle case where OTP sending failed
            // setStatus(response.message || 'Failed to send OTP');
        }
        setTimeout(() => {
            setLoading(false)
        }, 500);

    }
    const closePopup = () => {
        setReConfirm(false)
        setShow(false)
    }
    const resend = () => {
        saveUserSetting()
    }
    return (
        <>
            <div className="d-flex justify-content-center  vh-100 p-3">
                {show ?
                    <>
                        <OtpPopup show={show} setShow={closePopup} values={values} data={data} reSendOtp={resend} />
                    </>
                    : <div className="bg-white d-flex flex-column  w-100 p-4" style={{ maxWidth: "800px" }}>
                        <div className='d-flex justify-content-center w-100'>
                            <img width="220" alt="icon" src={"/media/images/new-com.png"} className="mb-4" />
                        </div>
                        <h2 className="mb-3 ">Review & Confirm Your Preferences</h2>
                        <p className="text-gray-600">Please take a moment to review your updated communication preferences below. Click Continue to proceed to the next step.</p>
                        <FormikComponent
                            labelMap={labelMap}
                            values={values?.communicationType}
                            disabled={true}
                        />
                        <div className="d-flex flex-row mt-4 gap-3 w-100">
                            <button className="btn btn-dark text-white fs-6 flex-grow-1" onClick={() => setReConfirm(false)}>Cancel</button>
                            <button className="btn btn-primary fs-6 flex-grow-1" onClick={() => saveUserSetting()}>Continue</button>
                        </div>
                    </div>
                }
                {loading && <FullPageLoader />}
            </div>

        </>
    )
}

export default ReConfirm